module.exports = __webpack_public_path__ + "static/media/info-activity.99b65ce9.jpeg";